import { CURRENCY, QUOTE_CLASSIFICATION } from 'src/constants/common';

export const CLASSIFICATION_OPTIONS = [
    {
        label: 'LTL',
        value: QUOTE_CLASSIFICATION.LTL,
    },
    {
        label: 'FTL',
        value: QUOTE_CLASSIFICATION.FTL,
    },
];

export const MAX_DIMENSION_LIMIT = 15;
export const initialQuoteDetailAction = {
    service: false,
    inBond: false,
    loadInsurance: false,
    dangerousGoods: false,
};
export const initAction = {
    mode: '',
    shipper: false,
    consignee: false,
    tailgate: false,
    unusual: false,
    service: false,
    delivery: false,
    limitedAccess: false,
    pickupDate: false,
};

export const currencies = [
    {
        value: CURRENCY.CAD,
        label: 'CAD',
    },
    {
        value: CURRENCY.USD,
        label: 'USD',
    },
];

export const DANGER_TYPE_LIST = [
    { name: 'Limited Quantity', value: 'limited-quantity' },
    { name: '500 kg Exemption', value: 'exemption-500-kg' },
    { name: 'Fully Regulated', value: 'fully-regulated' },
];

export const PACKAGING_GROUP_OPTIONS = [
    { label: 'PG I', value: 'PGI' },
    { label: 'PG II', value: 'PGII' },
    { label: 'PG III', value: 'PGIII' },
];

export const EDIT_QUOTE_ERROR_FIELDS = {
    SHIPPER_DETAILS: [
        'shipperFullAddress',
        'shipperLatitude',
        'shipperLongitude',
        'shipperCity',
        'shipperState',
        'shipperCountry',
        'shipperStreetNumber',
        'shipperPostal',
        'shipperCompanyName',
        'pickupDate',
        'pickupSensitivity',
        'pickupEndDate',
        'pickupWindowType',
        'pickupStartTime',
        'pickupEndTime',
    ],
    CONSIGNEE_DETAILS: [
        'consigneeFullAddress',
        'consigneeLatitude',
        'consigneeLongitude',
        'consigneeCity',
        'consigneeState',
        'consigneeCountry',
        'consigneeStreetNumber',
        'consigneePostal',
        'consigneeCompanyName',
        'deliverySensitivity',
        'deliveryDate',
        'deliveryEndDate',
        'deliveryWindowType',
        'deliveryStartTime',
        'deliveryEndTime',
    ],
    SHIPMENT_DETAILS: ['classification', 'urgency', 'primaryEquipmentType', 'primaryEquipmentTypeFullName', 'weightMeasurement', 'lengthMeasurement', 'insuranceCommodity', 'insuranceCommercialValue'],
    DIMENSIONS: ['dimensions', 'totalWeight', 'linearFootage'],
    FTL: ['totalWeight', 'linearFootage'],
};

export const initialQuoteAction = {
    weightMismatch: false,
    linearFootageMismatch: false,
    weightLinearFootageMismatch: false,
    tailgate: false,
    data: null,
};

export const shipperFormKeys: Record<string, string> = {
    shipperFullAddress: 'fullAddress',
    shipperAddress1: 'address1',
    shipperCity: 'city',
    shipperState: 'state',
    shipperCountry: 'country',
    shipperPostal: 'postal',
    shipperLatitude: 'latitude',
    shipperLongitude: 'longitude',
    shipperStateCode: 'stateCode',
    shipperCountryCode: 'countryCode',
    shipperStreetNumber: 'streetNumber',
    shipperCompanyName: 'companyName',
};

export const consigneeFormKeys: Record<string, string> = {
    consigneeFullAddress: 'fullAddress',
    consigneeAddress1: 'address1',
    consigneeCity: 'city',
    consigneeState: 'state',
    consigneeCountry: 'country',
    consigneePostal: 'postal',
    consigneeLatitude: 'latitude',
    consigneeLongitude: 'longitude',
    consigneeStateCode: 'stateCode',
    consigneeCountryCode: 'countryCode',
    consigneeStreetNumber: 'streetNumber',
    consigneeCompanyName: 'companyName',
};
